import React, { useState } from 'react';
import { Container } from 'react-bootstrap';

import MetaTags from '@components/MetaTags';
import Spinner from '@components/Spinner';
import { usePartnersFeatured, usePartnersFeed, usePartnersSubscriberCouncil } from '@hooks';
import useScrollToAnchor from '@hooks/useScrollToAnchor';
import { partners_list_path } from '@routes';
import { PARTNER_OG_IMAGE_PATH } from '@utils/constants';

import FeaturedPartnerContainer from './FeaturedPartnerContainer';
import PartnerHeader from './PartnerHeader';
import PartnersFeed, { FeedProps } from './PartnersFeed';
import PartnershipOpportunitiesSection from './PartnershipOpportunitiesSection';
import SubscriberCouncilContainer from './SubscriberCouncilContainer';

const DESCRIPTION =
  'Our readers are an elite audience of Founders, ' +
  'Partners, CEOs and senior executives who are highly engaged with our content. ' +
  'They come to The Information for their news and to stay ahead. ' +
  'They look to our brand partners to build relationships. ' +
  'The Information offers reach to tech leaders and financial power brokers. ' +
  'These are the people looking to innovative new partners and who can write the checks.';

const Partners = () => {
  const [page, setPage] = useState<number>(1);
  const { featuredPartners, isLoadingFeaturedPartners } = usePartnersFeatured();
  const {
    fetchNextPartnersFeedPage,
    hasNextPartnersFeedPage,
    isFetchingPartnersFeed,
    isLoadingPartnersFeed,
    partnersFeed,
  } = usePartnersFeed();
  const { scPartners, isLoadingScPartners } = usePartnersSubscriberCouncil();
  useScrollToAnchor(isLoadingFeaturedPartners || isLoadingPartnersFeed || isLoadingScPartners);

  const getPartnersFeedPath = (newPage: number) => partners_list_path({ page: newPage });
  const setPartnersFeedPage = (newPage: number) => {
    setPage(newPage);
    return fetchNextPartnersFeedPage({ pageParam: newPage });
  };

  return (
    <>
      <MetaTags
        title="The Information Partners"
        description={DESCRIPTION}
        ogSiteName="The Information"
        ogImagePath={PARTNER_OG_IMAGE_PATH}
      />
      {isLoadingFeaturedPartners || isLoadingScPartners ? (
        <Spinner />
      ) : (
        <>
          <Container>
            <PartnerHeader />
            {featuredPartners.length > 0 && (
              <FeaturedPartnerContainer featuredPartners={featuredPartners} />
            )}
            {scPartners.length > 0 && <SubscriberCouncilContainer scPartners={scPartners} />}

            <PartnersFeed
              feed={partnersFeed as FeedProps}
              getFeedPath={getPartnersFeedPath}
              hasNextPage={hasNextPartnersFeedPage}
              isFetchingFeed={isFetchingPartnersFeed}
              isLoadingFeed={isLoadingPartnersFeed}
              page={page}
              setFeedPage={setPartnersFeedPage}
            />
          </Container>
          <PartnershipOpportunitiesSection />
        </>
      )}
    </>
  );
};

export default Partners;
